import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Moon, Sun, Globe, MessageSquare } from 'lucide-react';
import { useTheme } from '../../core/contexts/ThemeContext';
import { useWindows } from '../../core/contexts/WindowContext';
export function MenuBar() {
  const {
    theme,
    setTheme,
    language,
    setLanguage,
    t
  } = useTheme();
  const {
    openWindow
  } = useWindows();
  const isLightTheme = theme === 'light';
  const [time, setTime] = useState(new Date());
  const [statusIndex, setStatusIndex] = useState(0);
  const statuses = ['Building: MvlCreative OS', 'Designing: Next project', 'Thinking: Product architecture'];
  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);
  useEffect(() => {
    const statusTimer = setInterval(() => {
      setStatusIndex(prev => (prev + 1) % statuses.length);
    }, 5000);
    return () => clearInterval(statusTimer);
  }, []);
  const toggleTheme = () => setTheme(isLightTheme ? 'dark' : 'light');
  const toggleLanguage = () => setLanguage(language === 'nl' ? 'en' : 'nl');
  return <div className={`fixed top-0 left-0 right-0 h-10 px-4 flex items-center justify-between z-[9999] backdrop-blur-xl border-b ${isLightTheme ? 'bg-white/50 border-black/[0.06]' : 'bg-[#1A1A1A]/50 border-white/[0.06]'}`} data-id="element-220">
      {/* Left: Logo */}
      <div className="flex items-center gap-4" data-id="element-221">
        <span className={`font-mono text-sm font-medium ${isLightTheme ? 'text-[#1A1A1A]' : 'text-[#E8E8E6]'}`} data-id="element-222">
          MvlCreative
        </span>
      </div>

      {/* Center: Status (Desktop only) */}
      <div className="hidden md:flex items-center justify-center flex-1 overflow-hidden" data-id="element-223">
        <AnimatePresence mode="wait" data-id="element-224">
          <motion.span key={statusIndex} initial={{
          opacity: 0,
          y: 5
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -5
        }} transition={{
          duration: 0.3
        }} className={`font-mono text-xs tracking-wider ${isLightTheme ? 'text-[#6B6B6B]' : 'text-[#9B9B9B]'}`} data-id="element-225">
            {statuses[statusIndex]}
          </motion.span>
        </AnimatePresence>
      </div>

      {/* Right: Controls & Time */}
      <div className="flex items-center gap-2 md:gap-4" data-id="element-226">
        <button onClick={() => openWindow('contact', t('contact.title'))} className="hidden sm:flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-[#C8956C] text-white text-xs font-medium hover:bg-[#B5825A] transition-colors shadow-sm" data-id="element-227">
          <MessageSquare className="w-3.5 h-3.5" data-id="element-228" />
          {t('work.cta_button')}
        </button>

        {/* Profile Avatar */}
        <div className={`w-6 h-6 rounded-full overflow-hidden border ${isLightTheme ? 'border-black/10' : 'border-white/20'}`} data-id="element-229">
          <img src="https://cdn.magicpatterns.com/uploads/6LWFciUpqXzvc9S9PJFRtx/Scherm%C2%ADafbeelding_2026-04-19_om_14.10.57.png" alt="Mick van Latum" className="w-full h-full object-cover" data-id="element-230" />
        </div>

        <div className="flex items-center gap-1 md:gap-2" data-id="element-231">
          <button onClick={toggleLanguage} className={`p-1.5 rounded-md transition-colors flex items-center gap-1.5 ${isLightTheme ? 'hover:bg-black/5 text-[#6B6B6B] hover:text-[#1A1A1A]' : 'hover:bg-white/10 text-[#9B9B9B] hover:text-[#E8E8E6]'}`} title="Toggle Language" data-id="element-232">
            <Globe className="w-3.5 h-3.5" data-id="element-233" />
            <span className="font-mono text-xs uppercase hidden sm:inline-block" data-id="element-234">
              {language}
            </span>
          </button>
          <button onClick={toggleTheme} className={`p-1.5 rounded-md transition-colors ${isLightTheme ? 'hover:bg-black/5 text-[#6B6B6B] hover:text-[#1A1A1A]' : 'hover:bg-white/10 text-[#9B9B9B] hover:text-[#E8E8E6]'}`} title="Toggle Theme" data-id="element-235">
            {isLightTheme ? <Moon className="w-3.5 h-3.5" data-id="element-236" /> : <Sun className="w-3.5 h-3.5" data-id="element-237" />}
          </button>
        </div>
        <span className={`hidden sm:inline-block font-mono text-xs ${isLightTheme ? 'text-[#1A1A1A]' : 'text-[#E8E8E6]'}`} data-id="element-238">
          {time.toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit'
        })}
        </span>
      </div>
    </div>;
}